export const languagesIconsMap = new Map([
  ['en-GB', 'flag-uk'],
  ['de', 'flag-de'],
]);
